<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Update Survey / Polls</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Update Survey / Polls</h2>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

        <div formArrayName="newSurveyGroups">
            <div *ngFor="let item of newSurveyGroups().controls; let i=index" [formGroupName]="i" class="mb-4 mb-md-5">
                <!-- Survey Details Section -->
                <div class="mb-4 mb-md-5">
                    <h5 class="mb-3 mb-md-4 font-weight-medium">Survey Details</h5>
                    <div class="row row-gap-4">
                                <div class="d-flex flex-column row-gap-1 col-12">
                                    <div class="d-flex flex-wrap column-gap-4">
                                        <div class="custom-control custom-radio flex-shrink-0">
                                            <input type="radio" class="custom-control-input" value="1"
                                                [(ngModel)]="pollsandsurvey.surveytype"
                                                (change)="checkSurveyType($event)" formControlName="surveytype"
                                                id="General">
                                            <label for="General"
                                                class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium">General
                                                Survey / Poll</label>
                                        </div>
                                        <div class="custom-control custom-radio flex-shrink-0">
                                            <input type="radio" class="custom-control-input" value="2"
                                                [(ngModel)]="pollsandsurvey.surveytype"
                                                (change)="checkSurveyType($event)" formControlName="surveytype"
                                                id="Event">
                                            <label for="Event"
                                                class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium">Event
                                                Specific Survey / Poll</label>
                                        </div>
                                    </div>
                                    <div *ngIf="newSurveyGroups().controls[i].get('surveytype').invalid && newSurveyGroups().controls[i].get('surveytype').touched"
                                        class="small text-danger">
                                        <div *ngIf="newSurveyGroups().controls[i].get('surveytype').errors?.required">
                                            Survey Type is required</div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                                    <label class="d-block font-weight-normal mb-1 mb-md-2">Survey Name</label>
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <input type="text" formControlName="name" id="name" class="form-control"
                                            placeholder="Name" [(ngModel)]="pollsandsurvey.name">
                                        <label>Name</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('name').invalid && newSurveyGroups().controls[i].get('name').touched"
                                            class="small text-danger">
                                            <div *ngIf="newSurveyGroups().controls[i].get('name').errors?.required">
                                                Name is required
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex flex-column row-gap-1 col-12 col-md-4" *ngIf="isshowEventCatList">
                                    <label class="d-block font-weight-normal mb-1 mb-md-2">IT Park Details</label>
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <select class="form-control" formControlName="parkid"
                                            (change)="getParkId($event)" [(ngModel)]="pollsandsurvey.parkid">
                                            <option value="">Select Park</option>
                                            <option value="{{parkdata.parkId}}" *ngFor="let parkdata of prakList">
                                                {{parkdata.parkName}}
                                            </option>
                                        </select>
                                        <label>Park</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('parkid').invalid && newSurveyGroups().controls[i].get('parkid').touched"
                                            class="small text-danger">
                                            <div *ngIf="newSurveyGroups().controls[i].get('parkid').errors?.required">
                                                IT Park is required
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex flex-column row-gap-1 col-12 col-md-4" *ngIf="!isshowEventCatList">
                                    <label class="d-block font-weight-normal mb-1 mb-md-2">IT Park Details</label>
                                    <div class="form-group floating_form_field mb-0 w-100">

                                        <!-- <select class="form-control" formControlName="parkid"
                                            (change)="getParkId($event)" [(ngModel)]="pollsandsurvey.parkid">
                                            <option value="">Select Park</option>
                                            <option value="{{parkdata.parkId}}" *ngFor="let parkdata of prakList">
                                                {{parkdata.parkName}}
                                            </option>
                                        </select>
                                        <label>Park</label> -->

                                        <ng-select [items]="prakList" [multiple]="true" bindLabel="parkName"
                                            [selectableGroup]="false" [closeOnSelect]="false" bindValue="parkId"
                                            [virtualScroll]="false" (change)="selectParkData($event)"
                                            (clear)="clearSelectedDataPark()" [clearable]="true"
                                            formControlName="parkid" (open)="onParkgSelectOpen(i)" class="custom"
                                            [(ngModel)]="selectedParkIds" appendTo="body">
                                            <div *ngIf="parkListLength > 0">
                                                <ng-template ng-header-tmp>
                                                    <div class="custom-control custom-checkbox">
                                                        <input id="parkid_all" type="checkbox"
                                                            class="custom-control-input" name="parkid_all"
                                                            (change)="selectAllPark($event)"
                                                            [checked]="selectedParkAll">
                                                        <label class="custom-control-label cursor-pointer"
                                                            for="parkid_all">All</label>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                let-index="index">
                                                <div class="custom-control custom-checkbox">
                                                    <input id="item-{{index}}" type="checkbox"
                                                        class="custom-control-input" name="item-{{index}}"
                                                        [ngModel]="item$.selected"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <label
                                                        class="custom-control-label cursor-pointer">{{item.parkName}}</label>
                                                </div>
                                            </ng-template>
                                        </ng-select>
                                        <label [ngClass]="parkSelectFocused && 'focused'">Select Park</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('parkid').invalid && newSurveyGroups().controls[i].get('parkid').touched"
                                            class="small text-danger">
                                            <div *ngIf="newSurveyGroups().controls[i].get('parkid').errors?.required">
                                                IT Park is required
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="d-flex flex-column row-gap-1 col-12 col-md-4" *ngIf="!isshowEventCatList">
                                    <label class="d-block font-weight-normal mb-1 mb-md-2">Select Building</label>
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <!-- <select class="form-control" formControlName="buildingid"
                                            (change)="getBuildingId($event)" [(ngModel)]="pollsandsurvey.buildingid">
                                            <option value="">Select Building</option>
                                            <option value="{{buildingdata.parkBuildingId}}"
                                                *ngFor="let buildingdata of buildingList">
                                                {{buildingdata.parkBuildingName}}
                                            </option>
                                        </select>
                                        <label>Building</label> -->
                                        <ng-select [items]="buildingListTempNew" [multiple]="true"
                                            bindLabel="buildingName" [groupBy]="groupbybuilding"
                                            [selectableGroup]="false" [selectableGroupAsModel]="false"
                                            [closeOnSelect]="false" bindValue="parkBuildingId" [virtualScroll]="false"
                                            (change)="selectBuildingData($event)" (clear)="clearSelectedData()"
                                            [clearable]="true" formControlName="buildingid"
                                            (open)="onBuildingSelectOpen(i)" class="custom"
                                            [(ngModel)]="selectedBuldingIds" appendTo="body">
                                            <div *ngIf="buildingListLength > 0">
                                                <ng-template ng-header-tmp>
                                                    <div class="custom-control custom-checkbox">
                                                        <input id="buildingid_all" type="checkbox"
                                                            class="custom-control-input" name="buildingid_all"
                                                            (change)="selectAll($event)"
                                                            [checked]="selectedBuildingAll">
                                                        <label class="custom-control-label cursor-pointer"
                                                            for="buildingid_all">All</label>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                let-index="index">
                                                <div class="custom-control custom-checkbox">
                                                    <input id="item-{{index}}" type="checkbox"
                                                        class="custom-control-input" name="item-{{index}}"
                                                        [ngModel]="item$.selected"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <label
                                                        class="custom-control-label cursor-pointer">{{item.buildingName}}</label>
                                                </div>
                                            </ng-template>
                                        </ng-select>
                                        <label [ngClass]="buildingSelectFocused && 'focused'">Select Building</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('buildingid').invalid && newSurveyGroups().controls[i].get('buildingid').touched"
                                            class="small text-danger">
                                            <div
                                                *ngIf="newSurveyGroups().controls[i].get('buildingid').errors?.required">
                                                Building is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column row-gap-1 col-12 col-md-4" *ngIf="!isshowEventCatList">
                                    <label class="d-block font-weight-normal mb-1 mb-md-2">Select Tenant</label>
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <!-- <select class="form-control" formControlName="tenantid"
                                            [(ngModel)]="pollsandsurvey.tenantid">
                                            <option value="">Select</option>
                                            <option value="{{tenantdata.tenantId}}"
                                                *ngFor="let tenantdata of companyList">
                                                {{tenantdata.tenantName}}
                                            </option>
                                        </select>
                                        <label>Tenant</label> -->
                                        <ng-select [items]="tenantListTempNew" [multiple]="true"
                                            bindLabel="parkTenantName" [groupBy]="groupbytenant"
                                            [selectableGroup]="false" [selectableGroupAsModel]="false"
                                            [closeOnSelect]="false" bindValue="parkTenantId" [virtualScroll]="false"
                                            (change)="selectTenantData($event)" (clear)="clearSelectedDataTenant()"
                                            [clearable]="true" formControlName="tenantid" (open)="onTenantSelectOpen(i)"
                                            class="custom" [(ngModel)]="selectedTenantIds" appendTo="body">
                                            <div *ngIf="companyListLength > 0">
                                                <ng-template ng-header-tmp>
                                                    <div class="custom-control custom-checkbox">
                                                        <input id="tenant_all" type="checkbox"
                                                            class="custom-control-input" name="tenant_all"
                                                            (change)="selectAllTenanat($event)"
                                                            [checked]="selectedTenantAll">
                                                        <label class="custom-control-label cursor-pointer"
                                                            for="tenant_all">All</label>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                                let-index="index">
                                                <div class="custom-control custom-checkbox">
                                                    <input id="item-{{index}}" type="checkbox"
                                                        class="custom-control-input" name="item-{{index}}"
                                                        [ngModel]="item$.selected"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <label
                                                        class="custom-control-label cursor-pointer">{{item.parkTenantName}}</label>
                                                </div>
                                            </ng-template>
                                        </ng-select>
                                        <label [ngClass]="tenantSelectFocused && 'focused'">Select Tenant</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('tenantid').invalid && newSurveyGroups().controls[i].get('tenantid').touched"
                                            class="small text-danger">
                                            <div *ngIf="newSurveyGroups().controls[i].get('tenantid').errors?.required">
                                                Tenant is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column row-gap-1 col-12 col-xl-4" *ngIf="isshowEventCatList">
                                    <label class="d-block font-weight-normal mb-1 mb-md-2">Select Event</label>
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <select class="form-control" formControlName="eventid"
                                            [(ngModel)]="pollsandsurvey.eventid">
                                            <option value="">Select Event</option>
                                            <option value="{{eventdata.eventID}}"
                                                *ngFor="let eventdata of eventMainList">
                                                {{eventdata.eventName}}
                                            </option>
                                        </select>
                                        <label>Event</label>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('eventid').invalid && newSurveyGroups().controls[i].get('eventid').touched"
                                            class="small text-danger">
                                            <div *ngIf="newSurveyGroups().controls[i].get('eventid').errors?.required">
                                                Event is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
                
                <!-- Date Range Section -->
                <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                    <h5 class="mb-3 mb-md-4 font-weight-medium">Set Date Range</h5>
                    <div class="row row-gap-4">
                        <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <input class="cal-icon form-control" autocomplete="off" (click)="d1.toggle()"
                                            (keypress)="$event.preventDefault()"
                                            (dateSelect)="updateSelectedDate($event)" id="startdate" type="text"
                                            formControlName="startdate" ngbDatepicker container='body'
                                            #d1="ngbDatepicker" [minDate]="minDate" required>
                                        <label>
                                            Start Date
                                        </label>
                                        <!-- <div class="col-2 pt-2">
                                                <div class="text-small">Start Date</div>
                                                <span class="title-text">{{formatDate}}</span>
                                            </div> -->
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('startdate').invalid && newSurveyGroups().controls[i].get('startdate').touched"
                                            class="small text-danger">
                                            <div
                                                *ngIf="newSurveyGroups().controls[i].get('startdate').errors?.required">
                                                Start Date is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                                    <div class="form-group floating_form_field mb-0 w-100">
                                        <input class="cal-icon form-control" autocomplete="off" (click)="d2.toggle()"
                                            (keypress)="$event.preventDefault()"
                                            (dateSelect)="updateSelectedToDate($event)" id="enddate" type="text"
                                            formControlName="enddate" ngbDatepicker container='body' #d2="ngbDatepicker"
                                            [minDate]="minDate" required>
                                        <label>
                                            End Date
                                        </label>
                                        <!-- <div class="col-2 pt-2">
                                                <div class="text-small">End Date</div>
                                                <span class="title-text">{{formatToDate}}</span>
                                            </div> -->
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div *ngIf="newSurveyGroups().controls[i].get('enddate').invalid && newSurveyGroups().controls[i].get('enddate').touched"
                                            class="small text-danger">
                                            <div *ngIf="newSurveyGroups().controls[i].get('enddate').errors?.required">
                                                End Date is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>

                <!-- <div class="row row-gap-4">
                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4 col-lx-4">
                        <div class="form-group mb-0 w-100">
                            <div class="col-12 d-flex">
                                <div class="form-check mr-4">
                                    <input type="radio" class="form-check-input" value="1"
                                        [(ngModel)]="pollsandsurvey.surveytype" (change)="checkSurveyType($event)"
                                        formControlName="surveytype" id="General" checked>
                                    <label for="General" class="form-check-label">General Survey/Poll</label>
                                </div>
                                <div class="form-check">
                                    <input type="radio" class="form-check-input" value="2"
                                        [(ngModel)]="pollsandsurvey.surveytype" (change)="checkSurveyType($event)"
                                        formControlName="surveytype" id="Event">
                                    <label for="Event" class="form-check-label">Event Specific Survey/Poll</label>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('surveytype').invalid && newSurveyGroups().controls[i].get('surveytype').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('surveytype').errors?.required">
                                    Survey Type is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row row-gap-4">
                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <input type="text" formControlName="name" id="name" class="form-control" placeholder="Name"
                                [(ngModel)]="pollsandsurvey.name">
                            <label>
                                Name
                            </label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('name').invalid && newSurveyGroups().controls[i].get('name').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('name').errors?.required">
                                    Name is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <select class="form-control" formControlName="parkid" (change)="getParkId($event)"
                                [(ngModel)]="pollsandsurvey.parkid">
                                <option value="">Select Park</option>
                                <option value="{{parkdata.parkId}}" *ngFor="let parkdata of prakList">
                                    {{parkdata.parkName}}
                                </option>
                            </select>
                            <label>Park</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('parkid').invalid && newSurveyGroups().controls[i].get('parkid').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('parkid').errors?.required">
                                    IT Park is required
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4" *ngIf="!isshowEventCatList">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <select class="form-control" formControlName="buildingid"
                                [(ngModel)]="pollsandsurvey.buildingid" (change)="getBuildingId($event)">
                                <option value="">Select Building</option>
                                <option value="{{buildingdata.parkBuildingId}}"
                                    *ngFor="let buildingdata of buildingList">
                                    {{buildingdata.parkBuildingName}}
                                </option>
                            </select>
                            <label>Building</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('buildingid').invalid && newSurveyGroups().controls[i].get('buildingid').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('buildingid').errors?.required">
                                    Building is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4" *ngIf="!isshowEventCatList">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <select class="form-control" formControlName="tenantid"
                                [(ngModel)]="pollsandsurvey.tenantid">
                                <option value="">Select Tenant</option>
                                <option value="{{tenantdata.tenantId}}" *ngFor="let tenantdata of companyList">
                                    {{tenantdata.tenantName}}
                                </option>
                            </select>
                            <label>Tenant</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('tenantid').invalid && newSurveyGroups().controls[i].get('tenantid').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('tenantid').errors?.required">
                                    Tenant is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4" *ngIf="isshowEventCatList">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <select class="form-control" formControlName="eventid" [(ngModel)]="pollsandsurvey.eventid">
                                <option value="">Select Event</option>
                                <option value="{{eventdata.eventID}}" *ngFor="let eventdata of eventMainList">
                                    {{eventdata.eventName}}
                                </option>
                            </select>
                            <label>Event</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('eventid').invalid && newSurveyGroups().controls[i].get('eventid').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('eventid').errors?.required">
                                    Event is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <input class="cal-icon form-control" autocomplete="off" (click)="d1.toggle()"
                                (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedDate($event)"
                                id="startdate" type="text" formControlName="startdate" ngbDatepicker #d1="ngbDatepicker"
                                required>
                            <label>
                                Start Date
                            </label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('startdate').invalid && newSurveyGroups().controls[i].get('startdate').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('startdate').errors?.required">
                                    Start Date is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column row-gap-1 col-12 col-md-4">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <input class="cal-icon form-control" autocomplete="off" (click)="d2.toggle()"
                                (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedToDate($event)"
                                id="enddate" type="text" formControlName="enddate" ngbDatepicker #d2="ngbDatepicker"
                                [minDate]="minDate" required>
                            <label>
                                End Date
                            </label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newSurveyGroups().controls[i].get('enddate').invalid && newSurveyGroups().controls[i].get('enddate').touched"
                                class="small text-danger">
                                <div *ngIf="newSurveyGroups().controls[i].get('enddate').errors?.required">
                                    End Date is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit" *ngIf="surveyEdit">Update</button>
        </div>
    </form>
</div>